<template>
  <div class="automation-stack">
    <AppPageHeader design="new" title="Follow-up Automation" compact />
    <AttentionLegend
      v-if="showGuide && options.data"
      :categories="options.data.attention_categories"
      :reasons="options.data.attention_reasons"
      @close="showGuide = false"
    />
    <Filters
      :filters="filters"
      :summary="summary"
      :options="options"
      @search="scheduleSearch"
      @change="changeFilters"
      @clear="clearFilters"
      @reload-summary="loadSummary"
      :refreshing="runs.loading"
      @guide="showGuide = true"
      @refresh="refresh"
      @reload-options="loadOptions"
    />
    <AppErrorState v-if="options.error" :message="options.error" @retry="loadOptions" />
    <AppErrorState v-if="summary.error" :message="summary.error" @retry="loadSummary" />
    <AppContentSkeleton v-if="runs.loading" label="Loading runs" :columns="runColumns" min-width="1200px" />
    <AppErrorState v-else-if="runs.error" :message="runs.error" @retry="loadRuns" />
    <RunTable v-else-if="runs.data" :data="runs.data" :page="Number(filters.page)" :list-query="$route.query" @page="changePage" />
  </div>
</template>
<script>
import {
  getFollowUpAutomationRuns,
  getFollowUpAutomationSummary,
  getFollowUpAutomationFilterOptions
} from '@/http'
import resources, { resource } from './resources'
import { listState, listParams } from './model'
import AppContentSkeleton from '@/components/AppContentSkeleton.vue'
import AppErrorState from '@/components/AppErrorState.vue'
import { RUN_COLUMNS } from './runColumns'
import RunTable from './RunTable.vue'
import Filters from './Filters.vue'
import AttentionLegend from './AttentionLegend.vue'

export default {
  name: 'FollowUpAutomationList',
  components: { AppContentSkeleton, AppErrorState, RunTable, Filters, AttentionLegend },
  mixins: [resources],
  data: () => ({
    filters: listState(),
    runs: resource(),
    summary: resource(),
    options: resource(),
    searchTimer: null,
    showGuide: false
  }),
  computed: { runColumns() { return RUN_COLUMNS } },
  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        clearTimeout(this.searchTimer)
        this.filters = listState(query)
        this.refresh()
      }
    }
  },
  created() {
    this.loadOptions()
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },
  methods: {
    loadOptions() {
      return this.loadResource(this.options, getFollowUpAutomationFilterOptions)
    },
    loadRuns() {
      return this.loadResource(this.runs, () => getFollowUpAutomationRuns(listParams(this.filters)))
    },
    loadSummary() {
      return this.loadResource(this.summary, () => getFollowUpAutomationSummary(listParams(this.filters, true)), true
      )
    },
    refresh() {
      this.loadRuns()
      this.loadSummary()
    },
    navigate() {
      clearTimeout(this.searchTimer)
      const query = Object.keys(this.filters).reduce((result, key) => {
        if (this.filters[key]) result[key] = String(this.filters[key])
        return result
      }, {})
      this.$router.push({ query }).catch(() => {})
    },
    scheduleSearch(value) {
      this.filters.search = value
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(this.applyFilters, 350)
    },
    applyFilters() {
      this.filters.page = '1'
      this.navigate()
    },
    changeFilters(patch) {
      Object.assign(this.filters, patch)
      this.applyFilters()
    },
    changePage(page) {
      this.filters.page = String(page)
      this.navigate()
    },
    clearFilters() {
      this.filters = listState()
      this.navigate()
    }
  }
}
</script>
